import { css } from '@emotion/react';
import { Gray, Main, White } from '@constants/color';

export const buttonStyle = css({
  width: 448,
  height: 60,
  backgroundColor: Gray.Gray70,
  color: Gray.Gray50,
  padding: '10px 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 6
});

export const focusedStyle = css({
  backgroundColor: Main.priBlue,
  color: White.White10
});

export const buttonText = css({
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '130%'
});
